import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WebAnalyticsService } from '@app/@core/services/web-analytics/web-analytics.service';
import { ValueHelperService } from '@app/business-ledger/services/value-helper.service';

@Component({
  selector: 'sp-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  constructor(private router: Router, private webAnalyticalService: WebAnalyticsService,
    private valueHelper: ValueHelperService) { }

  ngOnInit(): void {
  }

  navigateToHome() {
    this.router.navigateByUrl('/dashboard/home');
    const previosUrl = this.valueHelper.getPreviousUrlFor404() || '';
    console.log('previosUrl', previosUrl);
    this.webAnalyticalService.trackMoengageEvent('404 Page', { url: previosUrl })
  }

}
